import {isDevelop} from "@/config";

export const loggerMixin = {
    methods: {
        $_loggerMixin_consoleLog(msg) {
            if (isDevelop) {
                console.log(msg);
            }
        },
        $_loggerMixin_consoleError(msg) {
            if (isDevelop) {
                console.error(msg);
            }
        }
    }
}